import React, { Fragment, useState, useEffect } from 'react';
import { Select, DatePicker, Checkbox, Tag, Modal, Icon, PageHeader } from 'antd';
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import BreadcrumbComponent from "../BreadcrumbComponent";
import * as CPN from "antd";
import MessageValidation from "../MessageValidation";
import action from '../../../../actions/index';
import { isMobile } from 'react-device-detect';
import $ from 'jquery';
import Switch from './../../common/component/Switch';
import * as Func from '../../../../helpers/functions';
import Ripple from './Ripple';
import LanguageSelect from '../../modules/LanguageSelect';
import HmsTable from './Table';

export const WrapperComponent = (props) => {
    return (
        <div className="row mt-4">
            <div className="col-md-12">
                <div className="ibox">
                    <div className="ibox-content">
                        {
                            props.children
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};

export const HeaderComponent = props => {
    return (
        <PageHeader {...props} />
    )
};

export const ListComponent = HmsTable;

export class HeaderListComponent extends React.PureComponent {
    state = { movedBreadcrumb: false }
    componentDidMount() {
        this.moveBreadcrumb();
    }
    componentDidUpdate() {
        this.moveBreadcrumb();
    }
    moveBreadcrumb() {
        setTimeout(() => {
            var placeholder = $('.breadcrumb-placeholder');
            if (placeholder.length && this.br) {
                placeholder.empty();
                $(this.br).appendTo('.breadcrumb-placeholder');
                this.setState({ movedBreadcrumb: true })
            }
        }, 0);
    }
    renderBackButton() {
        return (this.props.onClickBack &&
            <Ripple onClick={this.props.onClickBack} className="header-back-button"><Icon type="left" /></Ripple>
        )
    }
    render() {
        const { t } = useTranslation;
        return (
            <Fragment>
                <div ref={r => { this.br = r }} className={!isMobile ? 'mt-3 flex-center justify-between' : ''}>
                    <BreadcrumbComponent
                        routeBread={this.props.path}
                        groupPath={this.props.groupPath}
                        useHomeIcon={isMobile}
                        extraBreadcrumbs={this.props.extraBreadcrumbs}
                    />
                    {!!this.props.onChangeLanguage && <LanguageSelect onChange={this.props.onChangeLanguage} />}
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    {!this.props.withoutHeader && <h2 className={`hmsTitleList`} style={{ marginTop: this.state.movedBreadcrumb && 5 }}>{this.renderBackButton()}{this.props.titleHeader}</h2>}
                    {(this.props.componentRight !== undefined) &&
                        <div className={`text-right`}>
                            {
                                this.props.componentRight
                            }
                        </div>
                    }
                </div>

            </Fragment>
        )
    }
}

export const PageListComponent = connect((rootState) => ({
    settingState: rootState.settingReducer,
}), (dispatch) => ({
    changeContentLanguage: (language) => dispatch(action.Setting.changeContentLanguage(language))
}))(({ className, children, settingState, onChangeLanguage }) => {
    const [contentLanguage, setContentLanguage] = useState(0);
    if (!contentLanguage && settingState.contentLanguage) {
        setContentLanguage(settingState.contentLanguage)
    }
    React.useEffect(() => {
        if (settingState.contentLanguage && contentLanguage && contentLanguage !== settingState.contentLanguage) {
            setContentLanguage(settingState.contentLanguage)
            return onChangeLanguage && onChangeLanguage(settingState.contentLanguage)
        }
    }, [settingState]);
    return (
        <div className={`row ${className}`}>
            <div className="col-lg-12">
                <div className="wrapper wrapper-content">
                    {
                        children
                    }
                </div>
            </div>
        </div>
    )
});


export const SelectComponent = (props) => {

    function onChange(value, all) {
        props.onChange({
            name: props.name,
            value: value,
            params: all ? Array.isArray(all) ? all.length > 0 ? all[0].props.params : {} : all.props.params : {}
        });
    }

    function onBlur() {
    }

    function onFocus() {
    }

    function onSearch(val) {
    }

    return (
        <Select
            {...props}
            className={`${props.className} ${props.name}`}
            onChange={onChange}
            onSearch={onSearch}
        >
            {
                props.hmsData && props.hmsData.length > 0 && props.hmsData.map((i, k) => {
                    return (
                        <Select.Option value={i.value} key={k} params={i}>{i.name}</Select.Option>
                    )
                })
            }
        </Select>
    );
};

export const DatePickerComponent = (props) => {

    function onChange(date, dateString) {
        return props.onChange({ name: props.name, value: dateString, fullValue: date });
    }

    if (props.hmsComponent === "MonthPicker") {
        return (
            <DatePicker.MonthPicker
                {...props}
                onChange={onChange}
            />
        );
    } else if (props.hmsComponent === "RangePicker") {
        return (
            <DatePicker.RangePicker
                {...props}
                onChange={onChange}
            />
        );
    } else if (props.hmsComponent === "WeekPicker") {
        return (
            <DatePicker.WeekPicker
                {...props}
                onChange={onChange}
            />
        );
    } else {
        return (
            <DatePicker
                {...props}
                onChange={onChange}
            />
        );
    }
};

export const CheckboxComponent = (props) => {

    function onChange(value) {
        props.onChange({ name: props.name, value: value.target.checked });
    }

    return (
        <Checkbox {...props} onChange={onChange}>{props.children}</Checkbox>
    );
};

export const StatusComponent = (props) => {
    let color = props.color;
    let label = props.label;
    return (
        <Tag color={color} key={props.key}>
            {label}
        </Tag>
    )
};

export const PopupModelComponent = (props) => {

    const handleCancel = () => {
        props.onClose(false)
    };

    const handleSubmit = () => {
        props.onSubmit(true)
    };

    return (
        <Modal
            {...props}
            onCancel={props.onClose}
            onOk={props.onSubmit}
            cancelText={props.cancelText ? props.cancelText : ''}
            okText={props.okText ? props.okText : ''}
            className={props.className ? props.className : ''}
        >
            {
                props.children
            }
        </Modal>
    )
};

export const ActionLinkButtonComponent = (props) => {
    return (
        <Link {...props} to={props.link} className={`mr-2 colorPrimary ${props.className}`}>
            <Icon type={props.iconaction} className="fs20" />
        </Link>
    )
};

export const ActionPopupButtonComponent = (props) => {
    return (
        <a {...props}>
            <Icon type={props.iconaction} className="fs20 colorPrimary" />
        </a>
    )
};

export const LoadingComponent = (props) => {
    return (
        <CPN.Spin {...props} size={`large`}>
            {
                props.children
            }
        </CPN.Spin>
    )
};

export const FormWrapperItem = (props) => {
    return (
        <div className={`col-md-12 ibox-content ${props.classParent ? props.classParent : ''}`}>
            <div className={`row ${props.classChildren ? props.classChildren : ''}`}>
                {
                    props.children
                }
            </div>
        </div>
    )
};

export const FormActionComponent = (props) => {
    const { t } = useTranslation();
    return (
        <div className={`row mt-${props.marginTop >= 0 ? props.marginTop : 3} form-action`}>
            <div className="col-md-12">
                <div className="ibox">
                    <CPN.Spin size={`large`} spinning={props.action === "UPDATE" ? props.isGetItem : false}>
                        <div className="">
                            {
                                // props.isShowHeader && (
                                //     <CPN.PageHeader onBack={() => props.findParentRoute()}
                                //                     title={props.titleBack}/>
                                // )
                            }
                            <form layout="inline" onSubmit={props.onSubmit}>
                                <div className={`row`}>
                                    {
                                        props.children
                                    }
                                    {!props.disabledFooter &&
                                        <div
                                            className={`col-md-12 ${props.submitButtonRight ? `text-right` : ''} ibox-content form-action-buttons`}>
                                            
                                            {
                                                (props.action === "UPDATE" || props.showActiveComponent) && props.activeComponent && (
                                                    typeof props.activeComponent === 'string' && props.activeComponent.toLowerCase() === 'switch'
                                                        ? <span className="active-detail-switch">
                                                            <span className="mr-2">{props.titleActiveComponent}</span>
                                                            <Switch className="mr-4" checked={props.statusActive}
                                                                onChange={(checked) => props.onChangeActive({
                                                                    name: `${props.statusActiveName ? props.statusActiveName : "deactivated"}`,
                                                                    value: checked,
                                                                })} />
                                                        </span>
                                                        : <CheckboxComponent
                                                            name={`${props.statusActiveName ? props.statusActiveName : "deactivated"}`}
                                                            className={`mr-4`}
                                                            onChange={props.onChangeActive}
                                                            checked={props.statusActive}>{props.titleActiveComponent}</CheckboxComponent>
                                                )
                                            }
                                            {props.additionalButton}
                                            {
                                                !props.disableButtonBack && (
                                                    <CPN.Button className="btn btn-dark"
                                                        onClick={() => {
                                                            if (props.onClickBack) {
                                                                return props.onClickBack()
                                                            }
                                                            return props.findParentRoute()
                                                        }}
                                                        // loading={props.isSubmit}
                                                        htmlType={`button`}>
                                                        {props.backButtonText || t('action.back')}
                                                    </CPN.Button>
                                                )
                                            }

                                            {
                                                !props.disableButtonSubmit && (
                                                    <CPN.Button className="btn btn-primary ml-2" loading={props.isSubmit}
                                                        disabled={props.isDisableAction}
                                                        {...props.propsButtonSubmit}
                                                        htmlType={`submit`}>
                                                        {props.titleButtonSubmit ? props.titleButtonSubmit : props.action === "CREATE" ? t('action.create') : t('action.update')}
                                                    </CPN.Button>
                                                )
                                            }
                                        </div>
                                    }
                                </div>
                            </form>
                        </div>
                    </CPN.Spin>
                </div>
            </div>
        </div>
    )
};

export const FormWrapperInputComponent = (props) => {
    const { t } = useTranslation();
    return (props.show !== false && props.hide !== true &&
        <div className={`form-group ${props.typeInput ? `row ${!props.labelHeaderStart && 'align-items-center'}` : ''} ${props.isValidation && props.validation ? 'validate-failed' : ''} ${props.className || ''}`}
            style={{ position: 'relative' }}>
            {
                props.typeInput ? (
                    <Fragment>
                        <div className={`${props.classLabel ? props.classLabel : 'col-md-3'} fs15`}>
                            {
                                props.isRequired && (typeof props.isRequired !== 'string' || props.isRequired.toLowerCase() === 'left') && (
                                    <span className={`colorRed mr-1`}>{props.isRequired === 'hide' ? '' : '*'}</span>
                                )
                            }
                            {(props.tooltip ? <CPN.Tooltip title={props.tooltip} placement={props.tooltipPlacement || 'top'}>{props.labelTitle}</CPN.Tooltip> : props.labelTitle ) }
                            {
                                props.isRequired && typeof props.isRequired === 'string' && props.isRequired.toLowerCase() === 'right' && (
                                    <span className={`colorRed mr-1`}>{props.isRequired === 'hide' ? '' : '*'}</span>
                                )
                            }
                            {
                                props.isValidation && !props.messageBelowInput && (
                                    <MessageValidation data={props.dataValidation}
                                        validation={props.validation}
                                        message={props.validation ? (typeof props.validation === 'string' ? props.validation : props.validation.messageError) : t('validation.statusCode.code.1')} />
                                )
                            }
                        </div>
                        <div className={`${props.classInputForm ? props.classInputForm : `col-md-9`}`}>
                            {
                                props.children
                            }
                        </div>
                        {
                            props.isValidation && props.messageBelowInput && (
                                <Fragment>
                                    <div className={`${props.classLabel ? props.classLabel : 'col-md-3'} fs15`}></div>
                                    <MessageValidation data={props.dataValidation} className={`pl-3 ${!props.classInputForm && `col-md-9`}`}
                                        validation={props.validation}
                                        message={props.validation ? (typeof props.validation === 'string' ? props.validation : props.validation.messageError) : t('validation.statusCode.code.1')} />
                                </Fragment>
                            )
                        }
                    </Fragment>
                ) : (
                        <Fragment>
                            <label className={props.classLabel ? props.classLabel : 'fs15'}>
                                {
                                    props.isRequired && (typeof props.isRequired !== 'string' || props.isRequired.toLowerCase() === 'left') && (
                                        <span className={`colorRed mr-1`}>{props.isRequired === 'hide' ? '' : '*'}</span>
                                    )
                                }
                                {(props.tooltip ? <CPN.Tooltip title={props.tooltip} placement={props.tooltipPlacement || 'top'}>{props.labelTitle}</CPN.Tooltip> : props.labelTitle ) }
                                {
                                    props.isRequired && typeof props.isRequired === 'string' && props.isRequired.toLowerCase() === 'right' && (
                                        <span className={`colorRed mr-1 title-required`}>{props.isRequired === 'hide' ? '' : '*'}</span>
                                    )
                                }
                                {
                                    props.isValidation && (
                                        <MessageValidation data={props.dataValidation}
                                            validation={props.validation}
                                            message={props.validation ? props.validation.messageError : t('validation.statusCode.code.1')} />
                                    )
                                }
                            </label>
                            {
                                props.children
                            }
                        </Fragment>
                    )
            }
            {props.visible === false &&
                <div className="bg-white form-input-visible-hide-backdrop"></div>
            }
        </div>
    )
};

export const ToolTipData = props => {
    const rows = props.data.map((row, index) => {
        return (
            <p key={index}>- {row.name}</p>
        )
    });

    return rows
};

export const FilterDropdown = props => {
    
    const handleSearch = () => {
        props.confirm();
    };

    const handleReset = () => {
        props.clearFilters();
    };
    
    useEffect(() => {
        if(!!props.defaultValue) {
            props.setSelectedKeys([props.defaultValue])
            props.confirm();
        }
    }, [])

    return (
        <CPN.Input
            type={props.inputType || 'text'}
            {...(props.inputProps || {})}
            value={(props.selectedKeys && props.selectedKeys[0]) || ''}
            onChange={e => props.setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch()}
            suffix={
                <div className="row align-items-center">
                    {Func.checkUndefine(props.selectedKeys && props.selectedKeys[0]) &&
                        <CPN.Icon type="close-circle" className="ant-input-clear-icon mr-1" onClick={() => handleReset()} size="small">
                        </CPN.Icon>}
                    <CPN.Button
                        className="mr-2"
                        type="primary"
                        onClick={() => handleSearch()}
                        icon="search"
                        size="small"
                    >
                    </CPN.Button>
                </div>
            }
        />
    )
};


export const FilterRadioDropdown = props => {

    const {
        defaultValue,
        confirm,
        selectedKeys,
        setSelectedKeys,
        dataFilters,
        handleReset
    } = props
    const normalizedSelectedKeys = Array.isArray(selectedKeys) ? selectedKeys : [];

    const handleFilter = () => {
        return !!confirm && confirm();
    };

    return (
        <div className="custom-options-filter">
            <div className="filter-options">
                <CPN.Radio.Group 
                    // onChange={handleFilter} 
                    value={normalizedSelectedKeys.length ? normalizedSelectedKeys[0] : defaultValue} 
                    onChange={e => setSelectedKeys([e.target.value])}>
                    {
                        dataFilters && !!dataFilters.length &&
                        dataFilters.map((item, index) => <CPN.Radio key={index} value={item.value}>{item.text}</CPN.Radio>)
                    }
                </CPN.Radio.Group>
            </div>
            <div className="button-action">
                <CPN.Button type="primary" icon='search' onClick={handleFilter}/>
                <CPN.Button onClick={handleReset} type="danger">{props.clearText || 'Clear filter'}</CPN.Button>
            </div>
        </div>
    )
}
